var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        ref: "ctomissTab",
        attrs: {
          type: "horizon",
          inlineLabel: true,
          dense: true,
          height: _vm.tabHeight,
          tabItems: _vm.tabItems,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  tag: "component",
                  attrs: {
                    popupParam: _vm.popupParam,
                    hazard: _vm.hazard,
                    attachInfo: _vm.attachInfo,
                    attachResultInfo: _vm.attachResultInfo,
                    contentHeight: _vm.contentHeight,
                    disabled: _vm.disabled,
                    editMode: _vm.editMode,
                  },
                  on: {
                    "update:popupParam": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:popup-param": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:hazard": function ($event) {
                      _vm.hazard = $event
                    },
                    "update:attachInfo": function ($event) {
                      _vm.attachInfo = $event
                    },
                    "update:attach-info": function ($event) {
                      _vm.attachInfo = $event
                    },
                    "update:attachResultInfo": function ($event) {
                      _vm.attachResultInfo = $event
                    },
                    "update:attach-result-info": function ($event) {
                      _vm.attachResultInfo = $event
                    },
                    "update:editMode": function ($event) {
                      _vm.editMode = $event
                    },
                    "update:edit-mode": function ($event) {
                      _vm.editMode = $event
                    },
                    getDetail: _vm.getDetail,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }